// extracted by mini-css-extract-plugin
export default {"pagination":"button_pagination__CSDP8","page-link":"button_page-link__Fr93R","button":"button_button__e01e1"};